/** customer service and admins have different level of permission
*   compare to HDMs.
*   layout and functionalities are slightly different.
*   Here extra functionalities needed for CS and AA
**/
'use strict';

import Loader from '../../../_modules/loader/loader';
import { toaster } from './_material';


let $body = $('body'),
    $hcpWorkplaceId = $('#HcpWorkplaceId'),
    $HcpSelect = $('#HcpName'),
    $transferFromHcpName = $('#TransferFromHcpName'),
    _isInvalid = [],
    dataParams = {},
    loader = new Loader();


/* Approve HCP:
** - display confirmation popup
** - add class "selected" to current row (needed to update values after API call)
** - add current workplace-id to confirmation button */
$('.js-approve-workplace').on('click', function (e){
    e.preventDefault();

    // console.log('js-approve-workplace');

    let isMobileDevice = Modernizr.mq('(max-width: 767px)'),
        workplaceId = $(this).closest('.workspace__detail').data('workplace-id'),
        institutionId = $(this).data('institution-id'),
        $row = $(this).closest('.workspace__row');

    // console.log(workplaceId+' is the workplace id');

    $('.workspace__row').removeClass('selected');
    $row.addClass('selected');

    $.fancybox.open('#approve-hcp-institution', {
        autoSize: false,
        closeBtn: false,
        fitToView: false,
        height: isMobileDevice == true ? 300 : 200,
        width: isMobileDevice == true ? 250 : 500,
        padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
        type: 'inline',
        wrapCSS: 'modal',
        helpers: {
            overlay:{
                closeClick: false
            }
        },
        beforeClose: function(){
        }
    });

    //set workplace id, needed when passing values to API
    $('.js-confirm-approve-hcp').attr('data-workplace-id', workplaceId );
});

/* Reject HCP:
** - display confirmation popup
** - add class "selected" to current row (needed to update values after API call)
** - add current workplace-id to confirmation button */
$('.js-reject-workplace').on('click', function (e){
    e.preventDefault();

    // console.log('js-reject-workplace');

    let isMobileDevice = Modernizr.mq('(max-width: 767px)'),
        workplaceId = $(this).closest('.workspace__detail').data('workplace-id'),
        institutionId = $(this).data('institution-id'),
        $row = $(this).closest('.workspace__row');

    // console.log(workplaceId+' is the workplace id');

    $('.workspace__row').removeClass('selected');
    $row.addClass('selected');

    $.fancybox.open('#reject-hcp-institution', {
        autoSize: false,
        closeBtn: false,
        fitToView: false,
        height: isMobileDevice == true ? 300 : 200,
        width: isMobileDevice == true ? 250 : 500,
        padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
        type: 'inline',
        wrapCSS: 'modal'
    });

    //set workplace id, needed when passing values to API
    $('.js-confirm-reject-hcp').attr('data-workplace-id', workplaceId );
});


/* Remove HCP:
** - Display modal window to transfer regimen
** - Populate modal window based on Institution Id 
** note: also used if user is HCPs wants to remove themselves
*/
$('.js-remove-workplace').on('click', function (e){
    e.preventDefault();

    let isMobileDevice = Modernizr.mq('(max-width: 767px)'),
        $this = $(this),
        workplaceId = $this.closest('.workspace__detail').data('workplace-id'),
        institutionId = $this.data('institution-id'),
        transferFromHcpName= $this.data('transfer-from-hcp-name'),
        dataParams = {'institutionId': institutionId},
        $row = $this.closest('.workspace__row');

    $('.workspace__row').removeClass('selected');
    $row.addClass('selected');

    if($this.data('institution-name')){
        let institutionName = $this.data('institution-name');

        $('#InstitutionName').val(institutionName); 
    }

    // clear dropdown from previous values
    $HcpSelect
        .empty()
        .append(
            $('<option></option>')
                .text('Select a HCP to transfer Regimens to *')
                .val('')
        );

    //display transfer from Hcp Name
    $transferFromHcpName
        .val(transferFromHcpName)
        .parent()
        .addClass('complete focus');

    //set workplace id, needed when passing values to API
    $('.js-transfer-regimen-to-hcp').attr('data-workplace-id', workplaceId );

    var encodedParams = jQuery.param(dataParams);
    $.ajax({
        url: '/api/hcpworkplaces/approvedhcpsbyinstitution?'+encodedParams,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        type: 'GET',
        success: function (data) {

            loader.fadeOut();

            // remove current HCP from the list of available HCPs
            var data = $.grep(data, function(e){
                 return e.key != workplaceId;
            });

            //display available HCPs based on institution id
            $.each(data, function(index, item){

                $HcpSelect.append(
                    $('<option></option>')
                        .text(item.value)
                        .val(item.key)
                );

            });

            //display confirmation popup
            $.fancybox.open('#remove-hcp-institution', {
                autoSize: false,
                closeBtn: false,
                fitToView: false,
                height: isMobileDevice == true ? 300 : 200,
                width: isMobileDevice == true ? 250 : 500,
                padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
                type: 'inline',
                wrapCSS: 'modal'
            });

        },
        error: function (error) {
            loader.fadeOut();
            toaster('Something went wrong.');
        }
    });

});






